// ELEVIO DIGITAL — Sticky Transparent Header
// File: assets/elevio-header.js

(function () {
  var header = document.querySelector('.header');
  if (!header) return;

  var scrollThreshold = 80;
  var lastScroll = 0;
  var ticking = false;

  function updateHeader() {
    var currentScroll = window.scrollY;

    if (currentScroll > scrollThreshold) {
      header.classList.add('elevio-header--scrolled');
    } else {
      header.classList.remove('elevio-header--scrolled');
    }

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load
  updateHeader();
})();